import { render, staticRenderFns } from "./DdCheckNew.vue?vue&type=template&id=6ae9298d&"
import script from "./DdCheckNew.vue?vue&type=script&lang=js&"
export * from "./DdCheckNew.vue?vue&type=script&lang=js&"
import style0 from "./DdCheckNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports